// Rank class of a board card, used by BoardEvent (ARCHITECTURE.md §5 example: rankClass "ace").
import { z } from 'zod';
export const RankClassSchema = z.enum(['ace', 'king', 'queen', 'broadway', 'middle', 'low']);
//# sourceMappingURL=rank-class.js.map